import { index as indexApi } from '@afosto/content/api/Index';

export const decodeRelativeDate = async value => {
  try {
    const response = await indexApi.decodeDateFilter(value);
    const { data } = response;

    return data;
  } catch (err) {
    return null;
  }
};

export default async values => {
  try {
    const promises = values.map(value => decodeRelativeDate(value));
    return Promise.all(promises);
  } catch (err) {
    return [];
  }
};
